<div class="page-content-small page-fill d-flex flex-column">
    <div *ngIf="paymentCredits" class="d-flex">
        <div class="d-flex">
            <div class="column ms-2 me-3"><span class="color-legend with-border payment-transaction-complete"></span> - Completed</div>
        </div>
    </div>
    <div class="flex-fill d-flex flex-column">
        <div class="m-1 grid-fill" *ngIf="paymentCredits">
            <dx-data-grid
                #dataGrid
                keyExpr="id"
                [showBorders]="true"
                [dataSource]="paymentCredits"
                [columnAutoWidth]="false"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                (onExporting)="onExporting($event)"
                (onOptionChanged)="onOptionChanged($event)"
                (onRowPrepared)="rowPrepare($event)"
            >
                <dxi-column dataField="id" width="90"></dxi-column>
                <dxi-column dataField="fromPaymentId" caption="Payment Id" width="100" cellTemplate="paymentIdLinkTemplate"></dxi-column>
                <dxi-column dataField="dealer.displayName" caption="Dealer" width="300"></dxi-column>
                <dxi-column dataField="creditOrderId" caption="Order Id" width="100" cellTemplate="creditOrderIdLinkTemplate"></dxi-column>
                <dxi-column dataField="creditAmount" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
                <dxi-column dataField="availableAmount" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
                <dxi-column dataField="notes" width="100"></dxi-column>
                <dxi-column dataField="quickBooksId" caption="QB Id" width="100"></dxi-column>
                <dxi-column dataField="quickBooksExport" caption="Exported" width="75"></dxi-column>
                <dxi-column dataField="created" width="125"></dxi-column>
                <dxi-column dataField="createdBy" width="125"></dxi-column>
                <dxi-column></dxi-column>

                <div *dxTemplate="let cell of 'paymentIdLinkTemplate'">
                    <a [routerLink]="['/payments/' + cell.data.fromPaymentId]">{{ cell.value }}</a>
                </div>

                <div *dxTemplate="let cell of 'creditOrderIdLinkTemplate'">
                    <a *ngIf="cell.data.creditOrderId" [routerLink]="['/sales-orders/' + cell.data.creditOrderId]">{{ cell.value }}</a>
                </div>

                <div *dxTemplate="let data of 'toolbarButtons'">
                    <button type="button" (click)="createCredit()" class="btn btn-secondary">New Credit Order</button>
                </div>

                <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
                <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-state-storing [enabled]="true" type="localStorage" storageKey="payment-credits-grid"></dxo-state-storing>
            </dx-data-grid>
        </div>
    </div>
</div>
